export default function teamIdForUid(uid) {
  return uid.split(':')[1];
}



/** WEBPACK FOOTER **
 ** ./src/utils/teamIdForUid.js
 **/